var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 212,
    viewBox: "0 0 237 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.686 136.66C233.956 140.303 233.005 143.945 231.877 147.544C227.83 160.537 221.173 173.176 211.994 183.638C202.816 194.144 191.426 202.517 180.832 207.093C170.194 211.602 160.617 212.068 151.439 210.802C142.327 209.536 133.259 206.627 123.527 204.961C103.733 201.54 84.5577 205.96 64.896 203.45C49.923 201.74 31.2565 187.036 16.9028 169C2.92505 151.32 -3.46668 133.239 2.28366 116.47C8.94079 96.4125 29.5093 81.5974 43.9957 63.6948C65.8028 35.6416 78.9843 -10.9362 139.319 2.32414C173.976 9.78724 180.279 35.8637 194.08 54.1883C207.925 72.8905 228.935 85.2623 234.73 108.296C236.897 117.047 236.632 126.82 234.686 136.66Z",
    fill: "#FBA81A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobOrange);
export default __webpack_public_path__ + "static/media/blob-orange.a9bc28da5e11d0269e88060349285805.svg";
export { ForwardRef as ReactComponent };